import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
    block: {
        display: 'block',
        marginBottom: 12,
    },
    label: {
        display: 'block',
        fontSize: 11,
        fontWeight: 700,
        textTransform: 'uppercase',
        letterSpacing: 0.4,
        color: '#8a92a3',
        marginBottom: 6,
    },
    wrap: {
        display: 'inline-flex',
        gap: 4,
        padding: 4,
        borderRadius: 10,
        backgroundColor: '#eef3f8',
    },
    button: {
        border: 0,
        background: 'transparent',
        color: '#1C375D',
        fontWeight: 700,
        fontSize: 13,
        padding: '8px 14px',
        borderRadius: 8,
        cursor: 'pointer',
    },
    active: {
        backgroundColor: '#1877F2',
        color: '#fff',
    },
    activeIg: {
        backgroundColor: '#E1306C',
        color: '#fff',
    },
    activeBoth: {
        backgroundColor: '#1C375D',
        color: '#fff',
    },
}));

/** Shown only on the Meta Ads dashboard — not on Google or Meta+Google combined view. */
export default function MetaPlatformSwitch({ value = 'both', onChange }) {
    const classes = useStyles();
    if (!onChange) return null;
    return (
        <div className={classes.block}>
            <span className={classes.label}>Meta platform</span>
            <div className={classes.wrap} role="tablist" aria-label="Meta platform">
                <button
                    type="button"
                    role="tab"
                    aria-selected={value === 'facebook'}
                    className={`${classes.button} ${value === 'facebook' ? classes.active : ''}`}
                    onClick={() => onChange('facebook')}
                >
                    Facebook
                </button>
                <button
                    type="button"
                    role="tab"
                    aria-selected={value === 'instagram'}
                    className={`${classes.button} ${value === 'instagram' ? classes.activeIg : ''}`}
                    onClick={() => onChange('instagram')}
                >
                    Instagram
                </button>
                <button
                    type="button"
                    role="tab"
                    aria-selected={value === 'both'}
                    aria-label="Both Facebook and Instagram"
                    className={`${classes.button} ${value === 'both' ? classes.activeBoth : ''}`}
                    onClick={() => onChange('both')}
                >
                    Both
                </button>
            </div>
        </div>
    );
}
